import React, {useContext, useEffect, useState} from "react";
import Header from "../../components/header/header";
import styles from "../../styles/dashboard.module.css";
import ChartComponent from "../../components/chart_component";
import axiosInstance from "../../AxiosInstance";
import Modal from "../../components/modal/modal";
import {DateInput, DateTimeInput, SelectInput, TextInput} from "../../components/input/inputs";
import MyContext from "../../Context";
import useMQTTService from "../../components/mqtt_service/mqtt_service";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import Loading from "../../components/loading/loading";
import VerticalInput from "../../components/vertical_input/vertical_input";
import {useTranslation} from "react-i18next";

export default function SingleGraphic() {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [form, setForm] = useState({});
    const [receivedData, setReceivedData] = useState([]);
    const [interval, setInterval] = useState("24h");
    const [showModal, setShowModal] = useState(false);
    const variable = JSON.parse(localStorage.getItem('variable'));
    const [showDashboardModal, setShowDashboardModal] = useState(false);
    const {dashboards} = useContext(MyContext);
    const device = JSON.parse(localStorage.getItem('device'));
    const navigate = useNavigate();

    const device_user = JSON.parse(localStorage.getItem('device_user'));

    // Para gráficos, usar el topic especial myindustrialdatagraph/{device.id}
    const {data} = useMQTTService('myindustrialdatagraph', device?.id);

    const navigationHeader = () => {
        return (
            <div className={'d-flex'}>
                <div style={{cursor: 'pointer'}} onClick={() => navigate('/resources')}>{device_user?.name}</div>
                <div className={'px-1'}>/</div>
                <div style={{cursor: 'pointer'}} onClick={() => navigate('/devices')}>{device?.name}</div>
                <div className={'px-1'}>/</div>
                <div style={{cursor: 'pointer'}} onClick={() => navigate('/variables')}>{variable?.variable.name}</div>
            </div>
        );
    }

    useEffect(() => {
        const variableId = variable?.id;
        if (!variableId) {
            setReceivedData([]);
            setLoading(false);
            return;
        }
        setError(null);
        setLoading(true);
        setForm({
            ...form,
            pk: variableId
        });
        const query = "variable=" + variableId + "&interval=" + interval;
        axiosInstance.get('graphs/?' + query).then((response) => {
            setLoading(false);
            setReceivedData(response.data);
            if (response.data && response.data.length > 0) {
                const graphicType = response.data[0].graph_type;
                setForm({
                    graph_type: graphicType,
                    green_1: variable?.low_threshold,
                    yellow_1: variable?.medium_threshold,
                    green_2: variable?.low_threshold_2,
                    yellow_2: variable?.medium_threshold_2,
                    disable_alerts: variable?.disable_alerts || false,
                });
            } else {
                setForm({
                    graph_type: 0,
                    green_1: variable?.low_threshold,
                    yellow_1: variable?.medium_threshold,
                    green_2: variable?.low_threshold_2,
                    yellow_2: variable?.medium_threshold_2,
                    disable_alerts: variable?.disable_alerts || false,
                });
            }
        }).catch((err) => {
            console.error('Error fetching graph data:', err);
            setLoading(false);
            setReceivedData([]);
            setError(t('variables.graphLoadError'));
        });
    }, [interval]);

    useEffect(() => {
        if(interval === '1h' || interval === '24h') {
            const variableId = variable?.id;
            if(variableId === data.variable_data_id) {
                if(receivedData.length > 0) {
                    setReceivedData([...receivedData, {
                        device: receivedData[0].device,
                        value: data.value,
                        variable_data_id: variableId,
                        variable_id: receivedData[0].variable_id,
                        x: data.x,
                    }]);
                }
            }
        }
    }, [data]);

    const getGraph = () => {
        let finalType = 'line';
        let storedType = 0;
        if (receivedData.length > 0) {
            storedType = receivedData[0].graph_type;
            if (storedType === 0) finalType = 'line';
            else if (storedType === 1) finalType = 'bar';
            else if (storedType === 2) finalType = 'area';
            else if (storedType === 3) finalType = 'radar';
            else if (storedType === 4) finalType = 'pie';
            else if (storedType === 5) finalType = 'step';
            else if (storedType === 6) finalType = 'timeline';
        }
        // Los canales booleanos se aprovisionan con graphic_type=0 (Line), que
        // dibuja una recta inútil. Si nadie eligió tipo a mano (0 = el default),
        // inferirlo del tipo de variable. Una elección explícita en Settings gana.
        if (storedType === 0) {
            let varType = Number(variable?.variable?.type);
            if (!varType || isNaN(varType)) {
                const dataType = variable?.variable?.data_type;
                if (dataType === 'boolean') varType = 5;
            }
            if (varType === 5) finalType = 'step';
        }
        return <ChartComponent name={'Test'} chartType={finalType} frequency={interval} data={receivedData} setShowModal={setShowModal} setShowDashboardModal={setShowDashboardModal}/>;
    }

    const saveGraph = () => {
        const variableId = variable?.id;
        axiosInstance.post('graphs/', {
            pk: variableId,
            graph_type: form.graph_type,
            green_1: form.green_1,
            green_2: form.green_2,
            yellow_1: form.yellow_1,
            yellow_2: form.yellow_2,
            disable_alerts: form.disable_alerts || false,
        }).then((response) => {
            localStorage.setItem('variable', JSON.stringify(response.data));
            window.location.reload();
        });
    }

    const addToDashboard = () => {
        const variableId = variable?.id;
        axiosInstance.post(`dashboard/${form.dashboard_id}/add_widget/`, {
            "name": form.widget_name,
            "key": variableId,
            "type": 3
        }).then((res) => {
            window.location.reload();
        })
    }

    const search = () => {
        if (!form['from'] || !form['to'] || form['from'] >= form['to']) {
            return;
        }
        const variableId = variable?.id;
        setError(null);
        setLoading(true)
        axiosInstance.get(`graphs/?variable=${variableId}&from=${form['from']}&to=${form['to']}`).then((response) => {
            setLoading(false);
            setReceivedData(response.data);
        }).catch((err) => {
            console.error('Error fetching graph data:', err);
            setLoading(false);
            setReceivedData([]);
            setError(t('variables.graphLoadError'));
        });
    }

    return (
        <div className={styles.dashboard_container}>
            <Header/>

            <Modal name={'Add to Dashboard'} show={showDashboardModal} setter={setShowDashboardModal} onClick={addToDashboard} buttonName={'Add'}>
                <div className={'mb-3'}>
                    <SelectInput name={'Dashboard'} internalName={'dashboard_id'} options={dashboards} form={form} setForm={setForm}/>
                    <TextInput name={'Name'} internalName={'widget_name'} form={form} setForm={setForm}/>
                </div>
            </Modal>

            <Modal name={'Settings'} show={showModal} setter={setShowModal} buttonName={'Save'} onClick={saveGraph}>
                <div className={'mb-3'}>
                    <SelectInput name={'Graphic Type'} internalName={'graph_type'} options={[{id: 0, name: 'Line'}, {id: 1, name:'Bar'}, {id: 2, name: 'Area'}, {id: 3, name: 'Radar'}, {id: 4, name: 'Pie'}, {id: 5, name: 'Step (Boolean)'}, {id: 6, name: 'Timeline (String)'}]} form={form} setForm={setForm}/>
                </div>
                <div className={'mb-3'}>
                    <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                        <input
                            type="checkbox"
                            checked={form.disable_alerts || false}
                            onChange={(e) => setForm({...form, disable_alerts: e.target.checked})}
                            style={{marginRight: '8px', width: '18px', height: '18px'}}
                        />
                        <span><b>Disable Alerts</b> (hide threshold lines)</span>
                    </label>
                </div>
                {!form.disable_alerts && (
                    <div>
                        <div><b>Actions</b></div>

                        <VerticalInput form={form} setForm={setForm}/>
                    </div>
                )}
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <div className='d-flex flex-row justify-content-between mt-3 flex-wrap'>
                    <div className={'d-flex align-items-center mb-2'}>
                        <FontAwesomeIcon icon={faArrowLeft} className={'pe-3'} size={'lg'} onClick={() => navigate('/variables')} role={'button'}/>
                        <div className={`${styles.title} fs-4`}>{navigationHeader()}</div>
                    </div>
                    <div className='d-flex flex-row mb-2'>
                        <div className={`d-flex flex-row rounded-2 me-2 ${styles.toggle}`}>
                            {/* eslint-disable-next-line no-implied-eval */}
                            <div onClick={() => setInterval("1h")} className={`${interval === "1h" ? styles.selected : styles.unselected }`}>1 hour</div>
                            <div className={styles.separator}/>
                            {/* eslint-disable-next-line no-implied-eval */}
                            <div onClick={() => setInterval("24h")} className={`${interval === "24h" ? styles.selected : styles.unselected }`}>24 hours</div>
                            <div className={styles.separator}/>
                            {/* eslint-disable-next-line no-implied-eval */}
                            <div onClick={() => setInterval("7d")} className={`${interval === "7d" ? styles.selected : styles.unselected }`}>7 days</div>
                            <div className={styles.separator}/>
                            {/* eslint-disable-next-line no-implied-eval */}
                            <div onClick={() => setInterval("1m")} className={`${interval === "1m" ? styles.selected : styles.unselected }`}>1 month</div>
                            <div className={styles.separator}/>
                            {/* eslint-disable-next-line no-implied-eval */}
                            <div onClick={() => setInterval("1y")} className={`${interval === "1y" ? styles.selected : styles.unselected }`}>1 year</div>
                        </div>
                    </div>
                </div>

                <div className={'d-flex pt-2 align-items-end flex-wrap'}>
                    <DateTimeInput name={'from'} form={form} setForm={setForm}/>
                    <div className={'pe-3'}/>
                    <DateTimeInput name={'to'} form={form} setForm={setForm}/>
                    <div className={'pe-3'}/>
                    <div style={{height: '48px', userSelect: "none", backgroundColor: '#FFF', textAlign: 'center', borderRadius: '6px', border: '#ccc 1px solid'}} role={'button'} className={'px-4 d-flex justify-content-center align-items-center'} onClick={() => search()}>
                        <div>Search</div>
                    </div>
                </div>

                <div>
                    {loading
                        ? <Loading/>
                        : error
                            ? <div className={'p-4 text-center'} style={{color: '#c0392b'}}>{error}</div>
                            : getGraph()}
                </div>
            </div>
        </div>
    );
}